<mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)">
    <mat-tab *ngFor="let tab of tabs; let i = index" [disabled]="tab.disabled">
      <ng-template mat-tab-label>
        {{ tab.label }}
      </ng-template>
      <ng-container *ngTemplateOutlet="tab.content"></ng-container>
    </mat-tab>
  </mat-tab-group>